import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ScoreUpdateContextType {
    scoreUpdated: boolean;
    triggerScoreUpdate: () => void;
}

const ScoreUpdateContext = createContext<ScoreUpdateContextType | undefined>(undefined);
    const ScoreUpdateProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [scoreUpdated, setScoreUpdated] = useState(false);
    const triggerScoreUpdate = () => {
        setScoreUpdated((prev) => !prev);
    };

    return (
        <ScoreUpdateContext.Provider value={{ scoreUpdated, triggerScoreUpdate }}>
            {children}
        </ScoreUpdateContext.Provider>
    );
};

export { ScoreUpdateContext, ScoreUpdateProvider };
